import type { IconProps } from '../types/IconProps.ts';
export const MenuVertical: IconProps = {
    name: 'MenuVertical',
    children: [
        `<rect width="2" height="2" x="11" y="4" rx="1" />`,
        `<rect width="2" height="2" x="11" y="11" rx="1" />`,
        `<rect width="2" height="2" x="11" y="18" rx="1" />`,
    ]
};